import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';

export interface IFiHttpPromise<T> extends Promise<T> {
    cancel?: () => void;
}

export function toFiPromise<T>(request: Observable<ArrayBuffer | Object>): Promise<T> {
    let subscription: Subscription;
    const promise: IFiHttpPromise<T> = new Promise<T>((resolve, reject) => {
        subscription = request.subscribe(
            (result) => resolve(<any>result), // result is null when '0' is in response body...
            (response) => {
                reject(response);
            },
        );
    });

    promise.cancel = () => {
        subscription.unsubscribe();
        /*            defer.reject({ //already rejected???
                        status: -1, //cancelled
                    });*/
    };
    promise.then = (function (origFunc) {
        return function () {
            const newPromise = origFunc.apply(this, arguments);
            newPromise.finally = promise.finally;
            newPromise.cancel = promise.cancel;
            return newPromise;
        };
    })(promise.then);

    return promise;
}
